import * as generateUseColdStart from './generateUseColdStart';
import * as generateUseLoadMoreItemsCallback from './generateUseLoadMoreItemsCallback';

const hooks = {
  ...generateUseColdStart,
  ...generateUseLoadMoreItemsCallback,
};
export default hooks;
